import { LogOut, Settings } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { NavLink, useNavigate } from 'react-router-dom'

import { useLogoutMutation } from '@/api/mutations/auth'
import { Button } from '@/components/ui/button'
import { useAuthStore } from '@/stores/auth.store'
import { useWorkbenchStore } from '@/stores/workbench.store'

export const UserMenu = () => {
  const { t } = useTranslation('common')
  const navigate = useNavigate()
  const user = useAuthStore((state) => state.user)
  const resetWorkbench = useWorkbenchStore((state) => state.reset)
  const logout = useLogoutMutation()

  const handleLogout = () => {
    logout.mutate(undefined, {
      onSettled: () => {
        resetWorkbench()
        navigate('/login', { replace: true })
      },
    })
  }

  return (
    <div className="flex items-center gap-2">
      <Button variant="ghost" size="sm" asChild>
        <NavLink to="/settings">
          <Settings className="h-4 w-4" aria-hidden="true" strokeWidth={1.5} />
          <span>{user?.name ?? t('default_user')}</span>
        </NavLink>
      </Button>
      <Button variant="ghost" size="icon" aria-label={t('actions.logout')} disabled={logout.isPending} onClick={handleLogout}>
        <LogOut className="h-4 w-4" aria-hidden="true" strokeWidth={1.5} />
      </Button>
    </div>
  )
}
